module.exports = __webpack_public_path__ + "static/img/Ícono_planif clases copia@4x.40207d3c.png";